import ResponsiveVideo from '../ResponsiveVideo';

export default class VideoPlayer {

    constructor(video) {

		this.video = video;

        if (!this.video) return;

		const videoElm = this.video.querySelector('video');

		new ResponsiveVideo(videoElm);

		this.button = this.video.querySelector('[data-play-video]');
		this.videoPlayer = this.video.querySelector('[data-video]');

		if(this.button){
			this.button.addEventListener('click', e => {
				this.playVideo();
			});
		}

		this.videoPlayer.addEventListener('play', () => {
			this.hideOverlay();
		});

		this.videoPlayer.addEventListener('pause', () => {
			this.showOverlay();
		});

		this.videoPlayer.addEventListener('ended', () => {
			this.showOverlay();
		});
	}

	showOverlay() {
		this.video.firstElementChild.classList.add('is-visible');
		this.button.focus();
	}

	hideOverlay() {
		this.video.firstElementChild.classList.remove('is-visible');
		this.videoPlayer.focus();
	}

	playVideo() {
		this.videoPlayer.play();
    }
}